import React from "react";
import { useNavigate } from "react-router-dom";

const Course = ({ batch,session,courseCode }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    // Redirect to a dummy route
    navigate(`/marksentryform/${batch.batch}/${session}/${courseCode}`); 
  };

  return (
    <div
      onClick={handleCardClick}
      className={`w-[160px] h-[150px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer hover:shadow-xl transition-shadow duration-300
        ${
          batch.submissionStatus === "marksentry"
            ? "bg-gradient-to-r from-pink-300 to-pink-600 hover:from-pink-500 hover:to-pink-700 text-white"
            : batch.submissionStatus === "gradecomputation"
            ? "bg-gradient-to-r from-yellow-300 to-yellow-200 hover:from-yellow-600 hover:to-yellow-400 text-black"
            : "bg-gradient-to-r from-green-300 to-green-200 hover:from-green-600 hover:to-green-400 text-black"
        }`
      }
    >
      <p className="w-full text-xs text-center mb-[10px]">{batch.batch}</p>
      <p className="w-full text-xs break-words whitespace-normal text-center">
        {batch.students.length + " STUDENTS"}
      </p>
    </div>
  );
};

export default Course;
